module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABN0lEQVRYR+2U3W0CMRCEdzpICXQQ0sFRQaADTwVROqAEOpjrAFIBpIJQQjpIOli0kpFQdD++44E82M/e3c/jmYU9+ODB860CVAWqAv9XAUlbMzuQPN+7KyS1ZrYl+f23V68Ckk4Ant39pauwFCoPX5vZcirAk5kFhLv7iuRv6dDrPUk7AG/5EZ1KDnpAUkCcAfxMhZCUAMjdSTK+oPOMmlDSMitxTCltSlSQtAawd/d3kruhmlGAKL6B2KeUONQw7gI4uvsHyTQGXASQIZpobGZtH4SkBYAvd/8kGcYbPcUAGaL3X8Mv+eXRsyk17SSAIQhJ4fIwbcStODGTATLENV4bkoebrMfLJy2uWQAZogXwGjENyYeyfncK+hrkdd3kNXsadVzHhdkKzBnWVVMBqgJVgapAVeACU3aYIRKkRH8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more_unfold.png
// module id = 366
// module chunks = 1